import React, { useState, useMemo } from "react";
import { ShoppingBag } from "lucide-react";
import { InventoryControlPanel } from "./InventoryControlPanel";
import { SalesTable } from "./SalesTable";
import { InvoicePreviewModal } from "./InvoicePreviewModal";
import { RecordSaleReturnModal } from "./RecordSaleReturnModal";
import SaleDispatchModal from "./SalesDispatchModal";

export const SalesView = ({
  search,
  setSearch,
  filters,
  setFilters,
  dynamicSettings,
  activeTab,
  consolidatedSales,
  parties,
  setSelReq,
  setSelSale,
  setSaleOpen,
  onExport,
  isExporting,
  onRefresh
}) => {
  const [previewSale, setPreviewSale] = useState(null);
  const [returnModalSale, setReturnModalSale] = useState(null);
  const [dispatchSale, setDispatchSale] = useState(null);

  const handleRecordReturn = (sale) => {
    setPreviewSale(null); // close preview
    setReturnModalSale(sale); // open return modal
  };

  const saleTypeFilter = filters?.saleType || 'all';
  const filteredSales = useMemo(() => {
    let result = consolidatedSales;
    if (saleTypeFilter !== 'all') {
      result = (consolidatedSales || []).filter(s => {
        const st = s.saleType || (s.recordType === 'material_request' ? 'Project Sale' : 'Direct Sale');
        return saleTypeFilter === 'project' ? st === 'Project Sale' : st === 'Direct Sale';
      });
    }
    console.log("SalesView Debug: consolidatedSales length =", consolidatedSales?.length);
    console.log("SalesView Debug: filteredSales length =", result?.length);
    console.log("SalesView Debug: First item in consolidated:", consolidatedSales?.[0]);
    return result;
  }, [consolidatedSales, saleTypeFilter]);

  return (
    <div className="space-y-6 animate-in fade-in duration-500">
      <InventoryControlPanel
        activeTab={activeTab}
        search={search}
        setSearch={setSearch}
        filters={filters}
        setFilters={setFilters}
        dynamicSettings={dynamicSettings}
        parties={parties}
        partyLabel="Projects/Customers"
        showStatusFilter={false}
        showVendorFilter={false}
        showCategoryFilter={false}
        showCustomerFilter={false} // Disabled as requested
        onExport={onExport}
        isExporting={isExporting}
      >
        {/* User requested to remove the All Types dropdown */}
        {/* <div className="bg-slate-50/50 p-1 rounded-md border border-slate-200/60 shrink-0">
          <select
            className="text-[13px] font-medium bg-white border border-slate-200 rounded-md px-2 py-1.5 focus:outline-none focus:ring-1 focus:ring-brand-blue text-slate-600 w-36"
            value={filters?.saleType || 'all'}
            onChange={e => setFilters(prev => ({ ...prev, saleType: e.target.value }))}
          >
            <option value="all">All Types</option>
            <option value="retail">Direct Sale</option>
            <option value="project">Project Sale</option>
          </select>
        </div> */}
      </InventoryControlPanel>
      <SalesTable
        sales={filteredSales}
        onView={(s) => {
          if (s.recordType === 'material_request') {
            setSelReq(s.originalRequest || s);
          } else {
            setPreviewSale(s);
          }
        }}
        onEdit={(s) => {
          if (s.recordType === 'sale') {
            setSelSale(s);
            setSaleOpen(true);
          }
        }}
        onRecordReturn={handleRecordReturn}
        onDispatch={(s) => setDispatchSale(s)}
      />
      <div className="hidden debug-data" data-sales-count={filteredSales.length}></div>

      <InvoicePreviewModal
        isOpen={!!previewSale}
        onClose={() => setPreviewSale(null)}
        sale={previewSale}
        onRecordReturn={handleRecordReturn}
      />

      <RecordSaleReturnModal 
        isOpen={!!returnModalSale}
        onClose={() => setReturnModalSale(null)}
        sale={returnModalSale}
        onReturnSuccess={() => {
          if (onRefresh) onRefresh();
          else window.location.reload();
        }}
      />
      <SaleDispatchModal
        isOpen={!!dispatchSale}
        onClose={() => setDispatchSale(null)}
        sale={dispatchSale}
        onRefresh={onRefresh}
      />
    </div>
  );
};

